import initCanvas from './modules/canvas.js';
import initTimer from './modules/time.js';
import initScrollReveal from './modules/reveal.js';

window.onload = () => {
  initScrollReveal();
  initCanvas();
}
